/**
 * Data Sanitizer Utility
 * Replaces null / undefined properties with safe defaults without mutating inputs.
 */

/**
 * Returns a sanitized copy of a record where null or undefined values are replaced with safe defaults
 * @param {Object} obj
 * @param {any} defaultValue
 * @returns {Object}
 */
export function sanitizeRecord(obj, defaultValue = "") {
  if (!obj || typeof obj !== "object") return obj || {};
  const cleaned = {};
  for (const [key, val] of Object.entries(obj)) {
    cleaned[key] = val === null || val === undefined ? defaultValue : val;
  }
  return cleaned;
}

/**
 * Sanitizes an array of records immutably
 * @param {Array<Object>} list
 * @param {any} defaultValue
 * @returns {Array<Object>}
 */
export function sanitizeRecords(list, defaultValue = "") {
  if (!Array.isArray(list)) return [];
  return list.map((item) => sanitizeRecord(item, defaultValue));
}
